<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Медиа запросы баннеров"
    >
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="banner_medias"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #top>
          <v-toolbar flat>
            <v-dialog v-model="dialog">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Новая запись
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Добавление медиа запроса</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col sm="12">
                      <v-text-field
                        v-model="editedItem.title"
                        label="Название"
                      />
                      <v-text-field
                        v-model="editedItem.name"
                        label="Код"
                      />
                      <v-text-field
                        v-model="editedItem.query"
                        label="Медиа запрос"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Отмена
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template #item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-dialog
            transition="dialog-bottom-transition"
            width="500"
            :value="deleteDialog === item.id"
            @input="toggleDeleteDialog($event, item.id)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Вы точно хотите удалить запись?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = null">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item.id)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { getBannerMedias, createImageMedia, updateImageMedia, deleteImageMedia } from '@/graphql/banner_medias'
import { startCase } from 'lodash-es'

export default {
  name: 'BannerMedias',
  components: {
  },
  layout: 'dashboard',
  apollo: {
    banner_medias: {
      query: getBannerMedias,
      variables () {
      },
      update: data => data?.imageMedias,
      result ({ data }) {
        this.totalCount = data?.imageMedias?.length
      }
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      totalCount: 0,
      active: [],
      open: [],
      deleteDialog: false,
      dialog: false,
      newItem: true,
      parentSlug: 'main_page_join_us',
      parentCategories: [],
      editedItem: {},
      headers: [
        ['id', 'Id'],
        ['title', 'Название'],
        ['name', 'Код'],
        ['query', 'Медиа запрос'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  computed: {
    bannersData () {
      return this.banner_areas ?? []
    }
  },
  watch: {
    dialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    save () {
      const input = {
        title: this.editedItem.title,
        name: this.editedItem.name,
        mediaQuery: this.editedItem.query
      }
      if (this.newItem) {
        this.$apollo
          .mutate({
            mutation: createImageMedia,
            variables: {
              input
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_medias.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
      } else {
        this.$apollo
          .mutate({
            mutation: updateImageMedia,
            variables: {
              id: this.editedItem.id,
              input
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_medias.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
      }
      this.close()
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: deleteImageMedia,
            variables: {
              id
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_medias.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
